import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { Company } from 'src/models';
import { fetchCompanyAction } from 'src/services/company';

const companyEntityAdapter = createEntityAdapter({
  selectId: (company: Company) => company.id,
});

export const companySelectors = companyEntityAdapter.getSelectors();

const companySlice = createSlice({
  name: 'companies',
  initialState: companyEntityAdapter.getInitialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCompanyAction.fulfilled, (state, { payload }) => {
      companyEntityAdapter.upsertOne(state, payload);
    });
  },
});

const { reducer } = companySlice;

export default reducer;
